import { styled, Theme } from '@mui/material';
import { CoreDialog, CoreRadioGroup } from '@youscience/core';

export const sxStyles = {
  content: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '3rem 1rem 2.5rem',
  },
  titles: {
    '& > h3': {
      textAlign: 'center',
    },

    '& > p:last-of-type': {
      margin: '1rem 0 ',
    },
  },
  formWrap: {
    padding: '0 1.75rem',
  },
  alert: {
    display: 'flex',
    marginBottom: '1rem',
    alignItems: 'start',
    maxWidth: '450px',
  },
  shareInfo: (theme: Theme) => ({
    marginTop: '2.5rem',
    color: '#666666',

    '& > span:first-of-type': {
      color: theme.palette.primary.main,
      cursor: 'pointer',
    },
  }),
};

export const StyledRadioGroup = styled(CoreRadioGroup)(() => ({
  marginTop: '1rem',
  marginBottom: '1.5rem',
}));

export const StyledDialog = styled(CoreDialog)(() => ({
  '.MuiPaper-root': {
    borderRadius: '12px',
    maxWidth: '720px',
    width: '100%',
  },
}));
